(function () {
  if (window.eyeMaskUpsellInitialized) {
    return;
  }

  window.eyeMaskUpsellInitialized = true;

  function getUpsell(element) {
    if (!element) {
      return null;
    }

    return element.closest(
      '.cart-drawer-eye-mask-upsell, .cart-page-eye-mask-upsell'
    );
  }

  function getAddButton(upsell) {
    if (!upsell) {
      return null;
    }

    return upsell.querySelector('.eye-mask-add-to-cart');
  }

  function getSelectedTitle(upsell) {
    if (!upsell) {
      return null;
    }

    return upsell.querySelector('.eye-mask-selected-title');
  }

  function getProductImage(upsell) {
    if (!upsell) {
      return null;
    }

    return upsell.querySelector('.eye-mask-product-image');
  }

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.eye-mask-color-swatch');

    if (!swatch) {
      return;
    }

    const upsell = getUpsell(swatch);

    if (!upsell) {
      return;
    }

    if (swatch.disabled || swatch.classList.contains('disabled')) {
      return;
    }

    const variantId = swatch.dataset.variantId;
    const variantTitle = swatch.dataset.variantTitle || '';
    const variantImage = swatch.dataset.variantImage || '';

    if (!variantId) {
      return;
    }

    upsell
      .querySelectorAll('.eye-mask-color-swatch.selected')
      .forEach(function (item) {
        item.classList.remove('selected');
      });

    swatch.classList.add('selected');

    const selectedTitle = getSelectedTitle(upsell);

    if (selectedTitle) {
      selectedTitle.textContent = variantTitle;
    }

    const productImage = getProductImage(upsell);

    if (productImage && variantImage) {
      productImage.src = variantImage;
      productImage.removeAttribute('srcset');
      productImage.alt = variantTitle;
    }

    const addButton = getAddButton(upsell);

    if (addButton) {
      addButton.dataset.variantId = variantId;
      addButton.disabled = false;
    }
  });

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('.eye-mask-add-to-cart');

    if (!addButton) {
      return;
    }

    const upsell = getUpsell(addButton);

    if (!upsell) {
      return;
    }

    const variantId = addButton.dataset.variantId;

    if (!variantId || addButton.disabled) {
      return;
    }

    if (addButton.dataset.loading === 'true') {
      return;
    }

    const originalText = addButton.textContent.trim();

    const isCartPage = upsell.classList.contains(
      'cart-page-eye-mask-upsell'
    );

    const isDrawer = upsell.classList.contains(
      'cart-drawer-eye-mask-upsell'
    );

    addButton.dataset.loading = 'true';
    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    const cartAddUrl =
      window.Shopify.routes.root + 'cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response
            .json()
            .then(function (error) {
              throw error;
            });
        }

        return response.json();
      })
      .then(function (data) {
        console.log('Eye mask added:', data);

        if (isCartPage) {
          addButton.textContent = 'Added';

          setTimeout(function () {
            window.location.reload();
          }, 500);

          return;
        }

        if (isDrawer) {
          return fetch('/cart.js', {
            headers: {
              'Accept': 'application/json'
            }
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: cart
                })
              );

              const cartDrawer =
                document.querySelector('cart-drawer');

              if (
                cartDrawer &&
                typeof cartDrawer.renderContents === 'function'
              ) {
                return fetch('/?section_id=cart-drawer')
                  .then(function (response) {
                    return response.text();
                  })
                  .then(function (html) {
                    const parser = new DOMParser();

                    const doc = parser.parseFromString(
                      html,
                      'text/html'
                    );

                    const newDrawer =
                      doc.querySelector('cart-drawer');

                    if (newDrawer) {
                      cartDrawer.innerHTML =
                        newDrawer.innerHTML;
                    }

                    if (
                      typeof cartDrawer.open === 'function'
                    ) {
                      cartDrawer.open();
                    }
                  });
              }
            });
        }
      })
      .then(function () {
        if (isCartPage) {
          return;
        }

        addButton.textContent = 'Added';

        setTimeout(function () {
          const currentButton =
            getAddButton(upsell);

          if (currentButton) {
            currentButton.textContent = originalText;
            currentButton.disabled = false;
            currentButton.dataset.loading = 'false';
          }
        }, 1200);
      })
      .catch(function (error) {
        console.error(
          'Eye mask add to cart error:',
          error
        );

        const currentButton =
          getAddButton(upsell);

        if (currentButton) {
          currentButton.textContent = 'Add to cart';
          currentButton.disabled = false;
          currentButton.dataset.loading = 'false';
        }
      });
  });
})();
